package rendering

import androidx.compose.animation.core.Animatable
import androidx.compose.animation.core.spring
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch

/**
 * Manages board wall-wiggle animation state.
 *
 * When the player tries to move into a wall (piece doesn't move), the board
 * wiggles in the attempted direction to give tactile feedback.
 *
 * Call [triggerWiggle] with the attempted direction.
 * Read [offsetX] to get the current X translation to apply via graphicsLayer.
 * This offset is ADDED to the shake offset in the graphicsLayer block.
 */
class WiggleState {
    /** Animatable X translation for the wiggle effect. */
    val offsetX = Animatable(0f)

    /**
     * Triggers a wall wiggle in the given direction.
     *
     * @param scope     CoroutineScope to launch the animation in.
     * @param direction +1 for right wall, -1 for left wall.
     * @param maxOffset Maximum wiggle offset in pixels (default 6px).
     */
    fun triggerWiggle(scope: CoroutineScope, direction: Int, maxOffset: Float = 6f) {
        if (direction == 0) return
        scope.launch {
            // Snap to initial offset in the attempted direction
            offsetX.snapTo(direction * maxOffset)
            // Spring back to zero
            offsetX.animateTo(
                targetValue = 0f,
                animationSpec = spring(dampingRatio = 0.35f, stiffness = 400f),
            )
        }
    }
}
